import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fb-values',
  templateUrl: './fb-values.component.html',
  styleUrls: ['./fb-values.component.css']
})
export class FbValuesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
